import React from 'react';
import { motion } from 'framer-motion';
import { BadgeCheckIcon, ClockIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { company } from '../data/company';
const proofs = [{
  icon: ClockIcon,
  text: 'Sur place en 30 min dans la boucle de Seine'
}, {
  icon: BadgeCheckIcon,
  text: 'Prix annoncé au téléphone, devis signé avant travaux'
}, {
  icon: MapPinIcon,
  text: 'Atelier à Maisons-Laffitte, artisan indépendant'
}];
export function Hero() {
  return <section id="top" className="relative bg-ink-950 text-bone" data-id="element-133" data-mp="1274mtlq59a5n">
      <div className="mx-auto grid max-w-content items-center gap-12 px-5 pb-16 pt-14 lg:grid-cols-[1.15fr_0.85fr] lg:gap-16 lg:px-8 lg:pb-24 lg:pt-20" data-id="element-134" data-mp="xaxghrtu5wn6">
        <div data-id="element-135" data-mp="ncgjad4b0lso">
          <p className="mb-5 inline-flex items-center gap-2 border-l-2 border-brass pl-3 text-sm font-medium text-brass-light" data-id="element-136" data-mp="nczt16jsw3vm">
            {company.hours}
          </p>
          <h1 className="font-display text-4xl font-extrabold leading-[1.05] sm:text-5xl lg:text-[3.85rem]" data-id="element-137" data-mp="382fgbrjt9agi">
            Porte claquée, clé perdue,
            <br data-id="element-138" data-mp="3j9u06x1wdkkr" />
            serrure forcée&nbsp;?
            <span className="mt-3 block text-brass-light" data-id="element-139" data-mp="3o7lprkf2kuls">J’arrive.</span>
          </h1>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-ink-500" data-id="element-140" data-mp="3o59chkk9b8f2">
            {company.owner}, serrurier artisan installé à Maisons-Laffitte. J’interviens moi-même
            chez vous, dans les Yvelines, les Hauts-de-Seine et à Paris — ouverture de porte,
            changement de serrure, blindage et dépannage après effraction.
          </p>

          <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-141" data-mp="359j8xswoe3z2">
            <a href={company.phoneHref} className="group inline-flex items-center justify-center gap-3 rounded-sm bg-brass px-7 py-4 font-display text-lg font-bold text-ink-950 transition-colors duration-150 ease-out hover:bg-brass-light" data-id="element-142" data-mp="2qkmune40zuq0">
              <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-143" data-mp="2lla70r5byjmd" />
              {company.phone}
            </a>
            <a href="#tarifs" className="inline-flex items-center justify-center rounded-sm border border-ink-700 px-7 py-4 font-display text-base font-semibold text-bone transition-colors duration-150 ease-out hover:border-brass hover:text-brass-light" data-id="element-144" data-mp="s2b7hx6yyh4m">
              Voir les tarifs
            </a>
          </div>

          <ul className="mt-10 space-y-3 border-t border-ink-800 pt-7" data-id="element-145" data-mp="dbaoiy8lj4u8">
            {proofs.map(({
            icon: Icon,
            text
          }) => <li key={text} className="flex items-start gap-3 text-sm text-bone-dark" data-id="element-146" data-mp="161ay3ae1l63f">
                <Icon className="mt-0.5 h-4 w-4 flex-none text-brass" aria-hidden="true" data-id="element-147" data-mp="112g55fmd215l" />
                <span data-id="element-148" data-mp="x14pa1tagual">{text}</span>
              </li>)}
          </ul>
        </div>

        <motion.figure initial={{
        opacity: 0,
        scale: 0.98
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative" data-id="element-149" data-mp="x3h62bnb8ym2">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/0bb70795-e80d-4282-ae01-9bc9194927e9.jpg" alt={`${company.owner} installant un cylindre de sécurité sur une porte d’immeuble`} className="h-[380px] w-full rounded-sm object-cover object-center sm:h-[480px] lg:h-[560px]" data-id="element-150" data-mp="1x9ulmd6nbhoh" />
          <figcaption className="absolute bottom-0 left-0 right-0 bg-ink-950/90 px-5 py-4" data-id="element-151" data-mp="2b20qh34cm28m">
            <p className="font-display text-sm font-bold uppercase tracking-wide text-bone" data-id="element-152" data-mp="2fzamx2q5ne5y">
              {company.owner}
            </p>
            <p className="mt-1 text-xs text-ink-500" data-id="element-153" data-mp="2p0h6xls0j73y">
              Artisan serrurier depuis {company.since} · SIREN {company.siren}
            </p>
          </figcaption>
        </motion.figure>
      </div>
    </section>;
}